import React from "react";
import { Autocomplete, CircularProgress, SelectChangeEvent, TextField } from "@mui/material";
import { formatText } from "../../helpers";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import { fetchModuleAsync } from "../../redux/common/common.actions";
import { CustomTextField } from "../formComponents";
import { LoadState } from "../../constants/enum";

export const TableNameAutoComplete: React.FC<{
  tableType: "VIEW" | "BASE TABLE";
  selectedValue: any;
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  helperText?: string;
  onChange?: (value: string | null) => void;
}> = (props) => {
  const { tableType, name, selectedValue, placeholder, helperText,disabled, onChange } =
    props;

  const { tableNames, tableViews } = useAppSelector(
    (storeState: IStoreState) => storeState.common.modules
  );
  const finalData = tableType === "VIEW" ? tableViews : tableNames;
  console.log("finalData ===>", finalData)

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchModuleAsync(tableType));
  }, []);

  return (
    <>
      <Autocomplete
        sx={{
          ".MuiOutlinedInput-root": {
            paddingTop: "2px",
            paddingBottom: "2px",
            fontSize: "0.8rem",
            color: "rgb(38, 38, 38)",
          },
        }}
        value={
          finalData.data.find((option) => option === selectedValue) || null
        }
        options={finalData.data}
        autoHighlight
        disabled={disabled}
        getOptionLabel={(option) => formatText(option)}
        onChange={(e, newValue) => {
           if(onChange){
            onChange(newValue)
           }
          }}
        renderInput={(params) => (
            <CustomTextField
              {...params}
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {finalData.loading === LoadState.pending && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              disabled={disabled}
            />
          )}
      />
    </>
  );
};

